import { domain } from "./auth";

export const apiUrl = domain + '/users/v1';
export const apiUrl2 = domain + '/api/v1';
export const therapistUrl = domain + '/therapists/v1';
export const dashboardUrl = domain + '/dashboard/v1';
export const sessionUrl = domain + '/sessions/v1';

export const POST_LOGIN = apiUrl + "/login";
export const POST_OTP = apiUrl + "/verify-otp";
export const POST_RESEND_OTP = apiUrl + "/resend-otp";
export const POST_RESET_PASSWORD = apiUrl + "/reset-password";
export const POST_CHANGE_PASSWORD = apiUrl + "/change-password";
export const POST_FORGOT_PASSWORD = apiUrl + '/forget-password';
export const POST_PROFILE_DETAILS = apiUrl + "/profile";
export const POST_PROFILE_UPDATE = apiUrl + "/update";
export const POST_COUNTRY_CODE = apiUrl2 + '/get-countries';
export const POST_STATE_CODE = apiUrl2 + '/get-states';
export const POST_CITY_CODE = apiUrl2 + '/get-cities';
export const POST_GENDER = apiUrl2 + '/get-genders';
export const POST_ISSUES = apiUrl2 + '/get-issues';
export const POST_LANGUAGE = apiUrl2 + '/get-languages';
export const POST_MHA_UPDATE = apiUrl + '/update-mental-health-assessment';
export const POST_THERAPIST_LIST = therapistUrl + '/best-therapist';
export const POST_ThERAPIST_DETAILS = therapistUrl + '/details';
export const POST_THERAPIST_SLOTS = therapistUrl + '/available-slots';
export const POST_USER_SUMMARY = dashboardUrl + '/user-summary';
export const POST_BOOKING_APPOINMENT = sessionUrl + '/book-appointment';
export const POST_SESSION_LIST = sessionUrl + '/lists';
export const POST_SESSION_DETAILS = sessionUrl + '/details';
export const POST_SESSION_CANCEL = sessionUrl + '/cancel';
export const POST_SESSION_RESCHEDULE = sessionUrl + '/reschedule';
export const POST_RATING_REMARKS = therapistUrl + '/change-therapist';
export const POST_RELATION_LIST = apiUrl2 + '/get-relations';
export const POST_REASONS_LIST = apiUrl2 + '/get-cancel-reason';
export const POST_SENT_REQUEST_CARETEAM = apiUrl + "/sent-request-care-team";
